module.exports = __webpack_public_path__ + "img/google_integration_graphic.41ebf365.png";